import React, { useEffect, useState } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import AddNewUnit from "pages/AddNewUnit";
import Adesao from "modules/MI/pages/adesao";
import AdesaoEmail from "modules/MI/pages/adesao-email";
import AlterarSenha from "pages/AlterarSenha";
import BoletoRapido from "pages/BoletoRapido";
import Boletos from "pages/Boletos";
import Consumo from "pages/Consumo";
import DebitoAutomatico from "pages/DebitoAutomatico";
import EsqueciSenhaMI from "modules/MI/pages/esqueci-senha-mi";
import FaleConoscoMi from "pages/FaleConosco";
import Login from "modules/MI/pages/Login";
import MFARegister from "components/layout/home/MFARegister";
import MeusDados from "pages/MeusDados";
import Pesquisa from "modules/MI/pages/pesquisa";
import Portal from "pages/Portal";
import PreferenciaCobranca from "pages/PreferenciaCobranca";
import PrimeiroAcesso from "pages/PrimeiroAcesso";
import Profile from "pages/Profile";
import Religue from "pages/Religue";
import RetornarUnidade from "modules/MI/pages/retornar-unidade";
import TrocaTitularidade from "modules/MI/pages/troca-titularidade";
import UltragazEnergia from "pages/UltragazEnergia";
import UltragazEnergiaSucesso from "pages/UltragazEnergiaSucesso";
import VerificarEmail from "modules/MI/pages/verficar-email";
import { useAuth } from "hooks/authHook";

type RouteProps = {
  path: string;
  Component: JSX.Element;
};

const Routes = (): JSX.Element => {
  const { userData } = useAuth();

  const PublicRoutes = [
    { path: "/", Component: Login },
    { path: "/acessar", Component: Login },
    { path: "/validar-token", Component: MFARegister },
    { path: "/primeiro-acesso-mi", Component: PrimeiroAcesso },
    { path: "/troca-titularidade", Component: TrocaTitularidade },
    { path: "/esqueci-senha-mi", Component: EsqueciSenhaMI },
    { path: "/adesao", Component: Adesao },
    { path: "/adesao/confirmacao-email", Component: AdesaoEmail },
    { path: "/verificar-email", Component: VerificarEmail },
    { path: "/boleto-rapido", Component: BoletoRapido },
  ];

  const MIRoutes = [
    { path: "/portal", Component: Portal },
    { path: "/consulta-debitos", Component: Boletos },
    { path: "/adicionar-unidade", Component: AddNewUnit },
    { path: "/retornar-unidade", Component: RetornarUnidade },
    { path: "/religue", Component: Religue },
    { path: "/consumo", Component: Consumo },
    { path: "/meus-dados", Component: MeusDados },
    { path: "/meus-dados-novo", Component: Profile },
    { path: "/alterar-senha", Component: AlterarSenha },
    { path: "/fale-conosco", Component: FaleConoscoMi },
    { path: "/pesquisa", Component: Pesquisa },
    { path: "/debito-automatico", Component: DebitoAutomatico },
    { path: "/preferencia-cobranca", Component: PreferenciaCobranca },
    { path: "/ultragaz-energia", Component: UltragazEnergia },
    { path: "/ultragaz-energia/sucesso", Component: UltragazEnergiaSucesso },
  ];

  const customerType =
    userData.customerType ||
    localStorage.getItem("@UltragazEmpresarial:customerType");
  const hasAccessToken =
    userData.accessToken ||
    localStorage.getItem("@UltragazEmpresarial:accessToken");
  const hasRefreshToken =
    userData.refreshToken ||
    localStorage.getItem("@UltragazEmpresarial:refreshToken");

  const buildRoutes = (
    customerType,
    hasAccessToken,
    hasRefreshToken
  ): RouteProps[] => {
    let initalRoute = [];
    if (customerType === "MI" && hasAccessToken && hasRefreshToken) {
      initalRoute = [...PublicRoutes, ...MIRoutes];
    } else {
      initalRoute = PublicRoutes;
    }
    return initalRoute;
  };

  const [routes, setRoutes] = useState(
    buildRoutes(customerType, hasAccessToken, hasRefreshToken)
  );

  useEffect(() => {
    const customerType =
      userData.customerType ||
      localStorage.getItem("@UltragazEmpresarial:customerType");
    const hasAccessToken =
      userData.accessToken ||
      localStorage.getItem("@UltragazEmpresarial:accessToken");
    const hasRefreshToken =
      userData.refreshToken ||
      localStorage.getItem("@UltragazEmpresarial:refreshToken");
    setRoutes(buildRoutes(customerType, hasAccessToken, hasRefreshToken));
  }, [userData, setRoutes]);

  const moreProps = (path, Component, props): JSX.Element => {
    switch (path) {
      case "/redefinir-senha":
        return <Component {...props} step={3} />;
      default:
        return <Component {...props} />;
    }
  };

  return (
    <BrowserRouter>
      <Switch>
        {routes.map(({ Component, ...route }) => (
          <Route
            exact
            key={route.path}
            path={route.path}
            render={(props) => moreProps(route.path, Component, props)}
          />
        ))}
        <Redirect from="*" to="/" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
